<div class="mx-auto md:w-2/3 w-full">
  <h1 class="font-bold text-4xl">Editing studio</h1>

  <%= render "form", studio: @studio %>

  <div class="mx-auto flex">
  <input type="submit" class="rounded-lg px-5 bg-blue-600 text-white inline-block cursor-pointer" form="studio-form" value="Update Studio">

  <% unless @studio.id == 0 %>
  <%= button_to "Remove this studio", studio_path(@studio), class: "btn-grey my-0",
    disabled: @locked, method: :delete, form: { class: "inline", data: { turbo_confirm: "Are you sure?" } } %>
  <% end %>
  <%= link_to "Back to Studios", studios_path, class: "btn-green my-0" %>
  </div>

  <% if @pairs and @pairs.size > 0 %>
  <h2 class="mt-8 font-bold text-2xl">Associated studios</h2>
  <ul class="list-disc list-inside">
  <% @pairs.sort_by {|studio| studio.name}.each do |pair| %>
  <li class="group flex">
    <span class="leading-8 mr-4">&bull;&nbsp;<%= pair.name %></span>
    <%= button_to "Unpair", unpair_studio_path(@studio),
      params: { pair: pair.name },
      form: { class: "inline" },
      class: "group-hover:inline hidden x-2 rounded-lg py-1 px-2 text-white bg-red-600 font-medium" %>
  </li>
  <% end %>
  </ul>
  <% end %>
  </div>

</div>
